import { type ReactNode, useState } from "react";
import AdminSidebar from "./sidebars/AdminSidebar";

// Composant de mise en page spécifique pour le dashboard Administrateur
function AdminDashboardLayout({ children }: { children: ReactNode }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleSidebarCollapse = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <AdminSidebar onCollapsedChange={handleSidebarCollapse} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <main
          className={`flex-1 overflow-y-auto p-4 md:p-6 ${
            sidebarCollapsed ? "md:ml-16" : "md:ml-64"
          } transition-all duration-300`}
        >
          {children}
        </main>
      </div>
    </div>
  );
}

export default AdminDashboardLayout;
